export default "__VITE_ASSET__M1$sFEmd__"